import React, { useEffect, useRef, useState } from "react";
import styles from './Home.module.css'
import CanvasTest from "./CanvasTest";
import RoundelPicture from "../../elements/roundelPicture/RoundelPicture";
import { imgArray2 } from "../gallery/ImgArray";
import { NavLink, useNavigate } from "react-router-dom";
import ImgComponent from "../../elements/imgComponent/ImgComponent";

export default function Home(){

    const [selectedTech,setSelectedTech] = useState('');
    const [randIndex0,setRandIndex0] = useState(null);
    const [randIndex1,setRandIndex1] = useState(null);
    const [randIndex2,setRandIndex2] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const firstRandom = Math.floor(Math.random()*imgArray2.length);
        let secondRandom = Math.floor(Math.random()*imgArray2.length);
        while(secondRandom === firstRandom){
            secondRandom = Math.floor(Math.random()*imgArray2.length);
        }
        let thirdRandom = Math.floor(Math.random()*imgArray2.length);
        while(secondRandom === thirdRandom || firstRandom === thirdRandom){
            thirdRandom = Math.floor(Math.random()*imgArray2.length);
        }
        setRandIndex0(firstRandom);
        setRandIndex1(secondRandom);
        setRandIndex2(thirdRandom);
    },[]);

    return (
        <main>
            <section className={styles.landingBlock}>
                <div className={styles.canvasContainer}><CanvasTest/></div>
                <h1>Seb Record</h1>
                <h2>Creative Web Developer</h2>
            </section>
            <section className={styles.mediumWidth}>
                <div className={styles.intro}>
                    <div>
                        <p>Based in the South East of England I'm a web devloper with experience making both enticing websites and full stack web apps.<br/><br/>With a background in engineering and a love for creativity, web development is an industry that really lets me play to my own strengths. </p>
                    </div>
                    <div>
                        <RoundelPicture imgPath={'../imgs/compressed/IMG_7871.jpeg'}/>
                    </div>
                </div>
            </section>
            <section className={styles.colorWrapDustyGrape}>
                <div className={styles.mediumWidth}>
                    <div className={styles.technologies}>
                        <h3>Core Technologies</h3>
                        <div className={styles.technologyIcons}>
                            <div className={styles.iconCon} onClick={() => setSelectedTech((prev) => prev === 'js'? '' : 'js')}>
                                <img src={'./imgs/techIcons/js.svg'} style={{opacity: `${selectedTech === 'js'? 0.125 : 1}`}}/>
                                <div style={{opacity: `${selectedTech === 'js'? 1 : 0}`}}>JavaScript</div>
                            </div>
                            <div className={styles.iconCon} onClick={() => setSelectedTech((prev) => prev === 'reactjs'? '' : 'reactjs')}>
                                <img src={'./imgs/techIcons/reactjs.svg'} style={{opacity: `${selectedTech === 'reactjs'? 0.125 : 1}`}}/>
                                <div style={{opacity: `${selectedTech === 'reactjs'? 1 : 0}`}}>React JS</div>
                            </div>
                            <div className={styles.iconCon} onClick={() => setSelectedTech((prev) => prev === 'nodejs'? '' : 'nodejs')}>
                                <img src={'./imgs/techIcons/nodejs.svg'} style={{opacity: `${selectedTech === 'nodejs'? 0.125 : 1}`}}/>
                                <div style={{opacity: `${selectedTech === 'nodejs'? 1 : 0}`}}>Node JS</div>
                            </div>
                            <div className={styles.iconCon} onClick={() => setSelectedTech((prev) => prev === 'postgresql'? '' : 'postgresql')}>
                                <img src={'./imgs/techIcons/postgresql.svg'} style={{opacity: `${selectedTech === 'postgresql'? 0.125 : 1}`}}/>
                                <div style={{opacity: `${selectedTech === 'postgresql'? 1 : 0}`}}>PostgreSQL</div>
                            </div>
                            <div className={styles.iconCon} onClick={() => setSelectedTech((prev) => prev === 'mysql'? '' : 'mysql')}>
                                <img src={'./imgs/techIcons/mysql.svg'} style={{opacity: `${selectedTech === 'mysql'? 0.125 : 1}`}}/>
                                <div style={{opacity: `${selectedTech === 'mysql'? 1 : 0}`}}>MySQL</div>
                            </div>
                            <div className={styles.iconCon} onClick={() => setSelectedTech((prev) => prev === 'docker'? '' : 'docker')}>
                                <img src={'./imgs/techIcons/docker.svg'} style={{opacity: `${selectedTech === 'docker'? 0.125 : 1}`}}/>
                                <div style={{opacity: `${selectedTech === 'docker'? 1 : 0}`}}>Docker</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={styles.mediumWidth}>
                <div className={styles.gallerySection}>
                    <h3>Gallery</h3>
                    <div className={styles.galleryCircles}>
                        <div>
                            <NavLink target="_top" to={`/gallery/all?view=true&img=${imgArray2[randIndex0]?.imgName}`} >
                                <ImgComponent imgObject={imgArray2[randIndex0]} maxSize="px1000"/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target="_top" to={`/gallery/all?view=true&img=${imgArray2[randIndex1]?.imgName}`} >
                                <ImgComponent imgObject={imgArray2[randIndex1]} maxSize="px1000"/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target="_top" to={`/gallery/all?view=true&img=${imgArray2[randIndex2]?.imgName}`} >
                                <ImgComponent imgObject={imgArray2[randIndex2]} maxSize="px1000"/>
                            </NavLink>
                        </div>
                    </div>
                    <div className={styles.buttonCon}>
                        <NavLink target="_top" to={'/gallery'} >View More</NavLink>
                    </div>
                </div>
                
            </section>
        </main>
    )
}